import(/* webpackMode: "eager", webpackExports: ["LandingPage"] */ "/vercel/path0/components/landing-page.tsx");
